/*** IMPORTS FROM imports-loader ***/
var define = false;

// I changed these functions to support adding different 'hidden classes', to support multiple masks at once.
// This makes it easier to apply multiple filters at once on the home page.
// If you want to use these functions simply, you can still do so - the hiddenClass param is optional and
// defaults to 'hidden'.

let hiddenClasses = [];

function registerHiddenClass(hiddenClass = 'hidden') {
  if (!hiddenClasses.includes(hiddenClass)) {
    hiddenClasses.push(hiddenClass);
  }
  return hiddenClass;
}

export function hideElement(element, hiddenClass) {
  if (!(typeof element !== 'undefined' && element instanceof Element)) {
    return;
  }

  // Register the class in case it's the first time we're using it.
  hiddenClass = registerHiddenClass(hiddenClass);
  element.classList.add(hiddenClass);

  // Always hide if we are adding a hidden class.
  element.setAttribute('hidden', '');
  return element;
}

export function showElement(element, hiddenClass) {
  if (!(typeof element !== 'undefined' && element instanceof Element)) {
    return;
  }

  // Register the class in case it's the first time we're using it.
  hiddenClass = registerHiddenClass(hiddenClass);
  element.classList.remove(hiddenClass);

  let hasHiddenClass = false;
  // Array.some() is like forEach() but will short-circuit if we return true.
  hiddenClasses.some((className) => {
    if (element.classList.contains(className)) {
      hasHiddenClass = true;
      return true;
    }
  });

  // Only remove 'hidden' if we've removed ALL hidden classes.
  if (!hasHiddenClass) {
    element.removeAttribute('hidden');
  }
  return element;
}

